module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_hagaki-be7117394c2db252da15de90f32d3e1c.jpg";